import React, { useEffect, useState, useContext } from "react";
import { CusSwitch } from "../From/Switch";
import { CusRadio } from "../From/Radio";
import CheckIcon from "../From/CheckIcon";
import { Global } from "../../App";

function Tool_extraNeedLIst_stafforder({
  data,
  onOpenToggle,
  removeExtraSelected,
  removeAddOrderExtraSelected,
}) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedExtraOptionList, setSelectedExtraOptionList] = useState([]);
  const handleModalOpen = (extraOptionList) => {
    setSelectedExtraOptionList(extraOptionList);

    setIsChecked(true);
  };
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  // 如果有被選亮燈
  const hasSelectedModeOnNew = (extraOptionList) => {
    const selected = extraOptionList.some(
      (extraOption) => extraOption.selectedMode != 0
    );
  
    let hasItemInGlobal;
    if (globalState.staffInfo.takeOrderData.extraDataList) {
      hasItemInGlobal = extraOptionList.some((extraOption) =>
        globalState.staffInfo.takeOrderData.extraDataList.some((globalExtraData) =>
          globalExtraData.selectedItemIDs.includes(extraOption.id)
        )
      );
    }
    if (globalState.ordermode == "addorder") {
      if (selected) {
        return true;
      }
    } else {
      if (hasItemInGlobal) {
        return true;
      }
    }
  };

  useEffect(() => {
    //  給對單時 如果已經有選
    if (
      data.extraOptionList.some((extraOption) => extraOption.selectedMode === 1)
    ) {
      setIsChecked(true);
    }
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center pb-2 my-2 ">
        {data.selected ? (
          <span className="txtColorRed align-items-center">✻</span>
        ) : (
          <span className="p-1"></span>
        )}
        <h5 className="w-50 txtColorBrown">
          {data.langName}
        </h5>
        <div className="w-50 d-flex justify-content-end align-items-center  txtColorLightGreen">         
          <div className="d-flex justify-content-end">
            {hasSelectedModeOnNew(data.extraOptionList) ? (
              <a
                onClick={() => {
                  hasSelectedModeOnNew(data.extraOptionList);
                  onOpenToggle({
                    toggle: true,
                    needName: data.langName,
                    needType: data.type,
                    subArray: data.extraOptionList,
                    needId: data.id,
                  });
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0704 2.10052L21.8988 4.92895L19.7775 7.05027L16.9491 4.22185L19.0704 2.10052ZM16.2423 4.92896L19.0707 7.75738L7.75698 19.0711L4.92855 16.2427L16.2423 4.92896ZM4.22273 16.9498L7.05116 19.7782L3.51562 20.4853L4.22273 16.9498Z"
                    // fill="#b9b9b9"
                    fill="#599e0b98"
                  />
                </svg>
              </a>
            ) : (
              ""
            )}
            <div className="d-flex flex-wrap">
              {(() => {
                if (globalState.ordermode == "addorder") {
                  return data.extraOptionList
                    .filter((option) => option.selectedMode != 0)
                    .map((option, index) => (
                      <div key={index} className="mr-1">
                        <span>{option.langName}</span>
                      </div>
                    ));
                } 
                else {
                  if (globalState.customer.orderInfo.extraDataList) {
                    return data.extraOptionList
                      .filter((extraOption) =>
                        globalState.customer.orderInfo.extraDataList.some(
                          (globalExtraData) => globalExtraData.selectedItemIDs.includes(extraOption.id)
                        )
                      )
                      .map((option, index) => (
                        <div key={index} className="mr-1">
                          <span>{option.langName}</span>
                        </div>
                      ));
                  } 
                  else {
                    return data.extraOptionList
                      .filter((option) => option.selectedMode != 0)
                      .map((option, index) => (
                        <div key={index} className="mr-1">
                          <span>{option.langName}</span>
                        </div>
                      ));
                  }
                }
              })()}
            </div>
          </div>
          <label className="checkbox-label">
            <span className="custom-checkbox-icon">
              {hasSelectedModeOnNew(data.extraOptionList) ? <CheckIcon /> : ""}
            </span>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              hidden
              onClick={() => {
                if (hasSelectedModeOnNew(data.extraOptionList)) {
                  if (globalState.ordermode == "addorder") {
                    removeAddOrderExtraSelected(data.id);
                  } else {
                    removeExtraSelected(data.id);
                  }
                } else {
                  onOpenToggle({
                    toggle: true,
                    needName: data.langName,
                    needType: data.type,
                    subArray: data.extraOptionList,
                    needId: data.id,
                  });
                }
              }}
            />
            <span className="custom-checkbox" />
          </label>
        </div>
      </div>
    </div>
  );
}

export default Tool_extraNeedLIst_stafforder;
